import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import InvitationsTable from '@features/admin/invitations/components/InvitationsTable';
import SendInvitationModal from '@features/admin/invitations/components/SendInvitationModal';
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useEntityContext } from '@features/entity/hooks/usePermissions';

const ChurchInvitesPage: React.FC = () => {
  const { churchId } = useParams<{ churchId: string }>();
  const [showCreate, setShowCreate] = useState(false);
  const sid = Number(churchId);

  const { context } = useEntityContext();
  const [reloadSignal, setReloadSignal] = useState(0);

  return (
    <Container fluid className="py-4">
      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4">
        <div className="ntcog-page-title-block mb-0">
          <h1 className="ntcog-page-heading mb-1">Invitations</h1>
          <p className="text-muted mb-0">Manage invitations for this church</p>
        </div>
        {sid > 0 && (
          <RequirePermission mode="section" action={ACTION_CODES.SEND_INVITE_CHURCH} scopeType="CHURCH" scopeId={sid}>
            <Button variant="primary" onClick={() => setShowCreate(true)}>
              <i className="bi bi-send me-2" aria-hidden="true"></i>
              Invite User
            </Button>
          </RequirePermission>
        )}
      </div>

      <InvitationsTable scope="C" scopeRefId={sid} showPagination={true} reloadSignal={reloadSignal} />
      <SendInvitationModal
        show={showCreate}
        onHide={() => setShowCreate(false)}
        scope="C"
        scopeRefId={sid > 0 ? sid : undefined}
        scopeName={context?.scopeName}
        onSent={() => setReloadSignal((k) => k + 1)}
      />
    </Container>
  );
};

export default ChurchInvitesPage;
